import { slugRequest } from '../slugRequest';
import {
  ingameTestBaseUrl as testUrl,
  ingameBaseUrl as baseUrl,
} from '@/config/api';

// 订阅活动消息
export function subActMessage(params = {}): any {
  const path = '/gingame/messagecenter/subscription_message';

  const conf: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        game: 'gp_ingame',
        msgid: 'subscription',
        mtype: '3',
        schannel: 'ingame',
        templateid: '1',
        liveid: '',
        livetime: '',
        keyword1: '订阅标题',
        keyword2: '订阅内容',
        page: '',
      },
      params,
    ),
  };

  return slugRequest(conf);
}

// 订阅活动消息
export function queryActSub(ids: string | number): any {
  const path = '/gingame/messagecenter/query_subscription';

  const conf: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: {
      game: 'gp_ingame',
      msgid: 'subscription',
      liveids: ids,
    },
  };

  return slugRequest(conf);
}

/**
 * note: 批量查询用户关注的动态
 * @param query
 * @return {Promise<any>}
 */
export function queryAttentionDynamicList(query: {
  num: number;
  start: number;
  lastTime: number;
}) {
  const path = '/gingame/messagecenter/query_attention_works_list';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    method: 'GET',
    source: 'backEnd',
    type: 'api',
    isAuth: true,
    query: {
      game: 'gp',
      gameid: 'gp',
      msgType: 1070003,
      bid: 'ingame',
      channel: 1,
      ...query,
    },
    underlizeQuery: true,
  };
  return slugRequest(config);
}

// note: 获取未读消息条数
export function getUnreadMessageNums(msgType: string) {
  const path = '/php/ingame/messagecenter/query_not_read_nums.php';

  const config: ApiTypes.HttpRequestByJsonpConf = {
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    underlizeQuery: true,
    query: {
      msgType,
      game: 'gp',
      bid: 'ingame',
      gameid: 'gp',
      channel: 1,
    },
  };

  return slugRequest(config);
}

export function getMessageList(query: {
  msgType: string;
  num: number;
  start: number;
}) {
  const path = '/php/ingame/messagecenter/query_message.php';
  const config: ApiTypes.HttpRequestByJsonpConf = {
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    underlizeQuery: true,
    query: {
      ...query,
      game: 'gp',
      gameid: 'gp',
      bid: 'ingame',
      channel: 1,
    },
  };
  return slugRequest(config);
}
